<template>
    <div v-if="barangay" class="row">
      <el-drawer title="" :visible.sync="showVoters" direction="rtl" :before-close="getBarangay" size="50%"
        :destroy-on-close="true">
        <div >
          <barangay-voters-list :barangay="barangay"></barangay-voters-list>
        </div>
      </el-drawer>

      <div class="col-md-8">
        <el-card>
          <div>BARANGAY</div>
          <h5>{{ barangay.name }} ({{ barangay.code }})</h5>
          <div style="font-size: 50px;font-weight: bold;" class="text-primary">{{ barangay.voters_count }} VOTERS | {{ barangay.leaders_count }} LEADERS</div>
          <hr>
          <el-button type="primary" plain @click="handleManageVoters">MANAGE VOTERS</el-button>
          <el-button type="primary" plain @click="handleDownloadQr" v-loading="loadQr">DOWNLOAD QR</el-button>
          <el-button type="primary" plain @click="handleExportExcel" v-loading="loadExcel">DOWNLOAD EXCEL</el-button>

        </el-card>
      </div>
      <div class="col-md-7"></div>
      <div class="col-md-8" style="margin-top: 10px;">
        <barangay-leaders-list :barangay="barangay" :update="update"></barangay-leaders-list>
      </div>
    </div>
  </template>
  <script>
  
  import { Barangay } from '@/resources/barangay'
import BarangayLeadersList from './BarangayLeadersList.vue'
import BarangayVotersList from './BarangayVotersList.vue'
  
  export default {
  components: { BarangayLeadersList, BarangayVotersList },
    data() {
        return {
          loadExcel: false,
          loadQr: false,
          loading: false,
          barangay: null,
          showVoters: false,
          update: 0,
        }
    },
    created: function () {
        this.getBarangay()
    },
    methods: {
      handleManageVoters(){
        this.showVoters = true
      },
      handleExportExcel(){
        this.loadExcel = true

        Barangay.exportExcel(this.barangay.id).then(result => {
            const fileUrl = result.data.link; // Replace with your dynamic URL
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'filename.txt'; // Specify the file name
            link.click();
          })
          .catch(error => {
        
          }).finally(() => {
            this.loadExcel = false
          })
      },
      handleDownloadQr(){
        this.loadQr = true

        Barangay.downloadQr(this.barangay.id).then(result => {
            const fileUrl = result.data.link; // Replace with your dynamic URL
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'filename.txt'; // Specify the file name
            link.click();
          })
          .catch(error => {
        
          }).finally(() => {
            this.loadQr = false
          })
      },
      getBarangay(){
        this.loading = true
        this.showVoters = false

        Barangay.show(this.$route.params.id).then(result => {
            this.barangay = result.data.barangay
            this.update += 1
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style lang="scss"></style>
  